module.exports = __webpack_public_path__ + "static/media/Parsecc Logo.07901f87.png";